import { trackPromise } from 'react-promise-tracker';

export async function getTransmision(userToken) {

    return trackPromise(fetch('https://t41bx8uqf6.execute-api.us-east-2.amazonaws.com/prod/votacion/transmision', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify()
    }).then(data => data.json()))
}